$(document).ready(function () {
  /* -------------------------------
     VIDEO HOVER PLAY/PAUSE
  -------------------------------- */
  $('.product-card-wrapper').hover(
    function () { // mouseenter
      const videoEl = $(this).find('video')[0];
      if (videoEl) {
        videoEl.play().catch(function (err) {
          console.log('Video play prevented:', err);
        });
      }
    },
    function () { // mouseleave
      const videoEl = $(this).find('video')[0];
      if (videoEl) {
        videoEl.pause();
        videoEl.currentTime = 0;
      }
    }
  );

  /* -------------------------------
     TRUNCATE TEXT BY WORD COUNT
  -------------------------------- */
  var maxWords = 25; // how many words to show by default

  $('.rich-text__text').each(function () {
    var fullHtml = $(this).html();     // original HTML (with tags)
    var textOnly = $(this).text().trim(); // plain text
    var words = textOnly.split(/\s+/);

    if (words.length > maxWords) {
      var truncatedText = words.slice(0, maxWords).join(' ') + '...';

      // store original & truncated versions
      $(this).data('full-html', fullHtml);
      $(this).data('truncated-html', `<span class="truncated">${truncatedText}</span>`);

      // show truncated by default
      $(this).html($(this).data('truncated-html'));
    }
  });

  /* -------------------------------
     READ MORE / READ LESS TOGGLE
  -------------------------------- */
  $(document).on('click', '.read-more-btn', function () {
    var $text = $(this).closest('.rich-text__blocks').find('.rich-text__text');
    $text.html($text.data('full-html'));
    $(this).hide();
    $(this).siblings('.read-less-btn').show();
  });

  $(document).on('click', '.read-less-btn', function () {
    var $text = $(this).closest('.rich-text__blocks').find('.rich-text__text');
    $text.html($text.data('truncated-html'));
    $(this).hide();
    $(this).siblings('.read-more-btn').show();
  });
});